<script>
  import { useField } from 'vee-validate'

  export default {
    name: 'AppInput',
    props: {
      className: {
        type: String,
        default: 'form-input-component'
      },
      label: {
        type: String,
        default: ''
      },
      tooltip: {
        type: String,
        default: ''
      },
      modelValue: {
        type: [String, Number],
        default: ''
      },
      isInvalid: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      id: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off'
      },
      rules: {
        type: Object,
        default: () => ({})
      }
    },
    emits: ['focus', 'blur', 'update:modelValue'],
    setup(props, { emit }) {
      const showPassword = ref(false)
      const inputType = ref(props.type)

      const togglePasswordVisibility = () => {
        showPassword.value = !showPassword.value
        inputType.value = showPassword.value ? 'text' : 'password'
      }

      const { value, errorMessage, handleChange } = useField(() => props.name, props.rules, {
        syncVModel: true,
        validateOnValueUpdate: false
      })

      const alreadySubmittedOnce = inject('alreadySubmittedOnce', ref(false))

      const handleChangeValidation = value => {
        handleChange(value, alreadySubmittedOnce.value)
      }

      const handleFocus = () => {
        emit('focus')
      }

      const handleBlur = () => {
        emit('blur')
      }

      return {
        showPassword,
        value,
        inputType,
        togglePasswordVisibility,
        handleChangeValidation,
        errorMessage,
        handleFocus,
        handleBlur
      }
    }
  }
</script>

<template>
  <div
    :class="className"
    @mouseover="handleFocus"
    @mouseleave="handleBlur"
  >
    <label
      :for="id"
      class="ml-2"
    >
      {{ label }}
      <span
        v-if="tooltip"
        data-bs-toggle="tooltip"
        data-bs-placement="left"
        :title="tooltip"
      >
        <i class="bi bi-info-square-fill" />
      </span>
    </label>
    <i
      v-if="icon"
      :class="icon"
    />
    <input
      :id="id"
      v-model="value"
      :name="name"
      :type="inputType"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :class="{ invalid: isInvalid }"
      :autocomplete="autocomplete"
      @input="handleChangeValidation"
    />
    <i
      v-if="type === 'password'"
      class="toggle-icon-password bi bi-eye-fill"
      :class="showPassword ? `bi-eye-fill` : `bi-eye-slash-fill`"
      @click="togglePasswordVisibility"
    />
    <slot />
  </div>
</template>

<style scoped lang="scss">
  .toggle-icon-password {
    &.bi {
      cursor: pointer;
      float: right;
      position: relative;
      font-size: 17px;
      padding-right: 12px;
      margin-top: -52px;
    }
  }
</style>
